import { belongsTo, Model } from 'miragejs';

export default Model.extend({
  client: belongsTo(), // TODO: Remove when feature--consent-management is cleaned up
  publicApiClient: belongsTo(),
});
